import {
    CardContent,
    Typography
} from '@mui/material';
import { useUnit } from 'effector-react';
import { $userData } from '../store/userData';

export const CarCard = ({ car }) => {

    const userData = useUnit($userData);

    return (
        <div style={{padding: "5px"}}>
            <Typography variant="h6">
                {car.model.name}
            </Typography>
            {car.description?.split("\n").map((text, index) => (
                <p style={{ textAlign: "left", margin: 0, overflowWrap: "break-word" }} key={index}>{text}</p>

            ))}
        </div>
    );
};